module.exports = __webpack_public_path__ + "4865c715d8ab687ff7fe0c6b506b4408.jpg";